import { mapGetters } from 'vuex'
import { toStoneBrand } from '@/utils/stone-rebrand.utils'

export default {
  computed: {
    ...mapGetters({
      account: 'account'
    })
  },
  watch: {
    name (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setDocumentTitle()
      }
    }
  },
  methods: {
    tabNameFormat () {
      const appTitle = toStoneBrand(process.env.VUE_APP_TITLE)
      return `${this.account.name} | ${this.$t(this.name)} - ${appTitle}`
    },
    setDocumentTitle () {
      document.title = this.tabNameFormat()
    }
  },
  created () {
    this.setDocumentTitle()
  },
  mounted () {
    this.setDocumentTitle()
  }
}
